import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Arranges the parts as the finder's bio list row or as the directory row.
   *
   * @type {String}
   * @default "directory"
   */
  layout: {
    type: String,
    default: "directory",
    validator: (value) => ["bio", "directory"].includes(value),
  },
  /**
   * The search result object: a Physician or Location payload, named by its `resultType`. Object props have no
   * attribute form — set this as a DOM property (`.prop` in a template, `el.result = …` in script).
   *
   * @type {Object}
   * @storybook-control object
   * @default {}
   */
  result: {
    type: Object,
    default: () => ({}),
  },
  /**
   * Per-deployment display flags. `resultTemplate: "directory"` enables the wide directory layout;
   * the `showProvider*` booleans toggle individual attributes; `showProviderHoursBadge` fetches and
   * renders the location hours badge. Set as a DOM property, not an attribute.
   *
   * @type {Object}
   * @storybook-control object
   * @default undefined
   */
  resultConfig: {
    type: Object,
    default: undefined,
  },
  /**
   * Localised label strings for accepting-patients, LGBTQIA+ affirming care, and video-visit tiles.
   * Set as a DOM property, not an attribute.
   *
   * @type {Object}
   * @storybook-control object
   * @default {}
   */
  labels: {
    type: Object,
    default: () => ({}),
  },
  /**
   * The finder's slot settings for the bio layout's scheduling column: `slotsUi`, `startDate`,
   * `showYear`, `maxSlots`, the `sp-slot-cards` look settings, `showMultipleSchedulingTypes` and
   * `doctorMessages`. Set as a DOM property, not an attribute.
   *
   * @type {Object}
   * @storybook-control object
   * @default {}
   */
  scheduling: {
    type: Object,
    default: () => ({}),
  },
  /**
   * Keeps the bio layout in one stacked column until the card's container is wide (750px), where the default
   * switches to columns at 500px. A deployment sets it for every card through its `sp_components.yml` defaults.
   *
   * @type {Boolean|String}
   * @default false
   */
  stackuntilwide: booleanAttribute(),
});
